// extracted by css-extract-rspack-plugin
export default {"chip":"WicNqQXrHe8YCAnF","label":"W7grci1H4M4Llkmx","deleteButton":"tgLVQ9zLIRYDcCmO"};